var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "efhya",
    d: "M623 396a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efhyb",
    d: "M601 397a8 8 0 0 1-8-8 8 8 0 0 1 14.634-4.473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efhyc",
    d: "M595.03 423c.52-10.028 8.816-18 18.974-18s18.454 7.972 18.974 18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efhyd",
    d: "M601 397c-8.836 0-16 7.163-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efhye",
    d: "M620.3 384.627A8 8 0 1 1 627.001 397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efhyf",
    d: "M643 413c0-8.837-7.164-16-16-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-584 -380)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhya"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhyb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhyc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhyd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhye"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#efhyf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBlue);
export default __webpack_public_path__ + "static/media/group-blue.f2d814cb2a984bb4ce4f835313225cc8.svg";
export { ForwardRef as ReactComponent };